import { render } from "./InfoBox.vue?vue&type=template&id=24a805bd&scoped=true"
import script from "./InfoBox.vue?vue&type=script&lang=js"
export * from "./InfoBox.vue?vue&type=script&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=24a805bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a805bd"],['__file',"src/components/InfoBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24a805bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24a805bd', __exports__)) {
    api.reload('24a805bd', __exports__)
  }
  
  module.hot.accept("./InfoBox.vue?vue&type=template&id=24a805bd&scoped=true", () => {
    api.rerender('24a805bd', render)
  })

}


export default __exports__